<template>
  <div class="text-center grand-summary pt-1 pb-1 mb-0">
    <label class="mb-0" data-test="grandSummary" v-html="resultSummary"></label>
  </div>
</template>
<script>
export default {
  name: 'grand-summary',
  mounted() {
    this.get('/api/counters/totals', {}).then((resp2) => {
      if (resp2 != null) {
        this.summary.nOfProducts = resp2.totalProducts
        this.summary.nOfActiveProducts = resp2.activeProducts
        this.summary.nOfProductsUnderTest = resp2.productsUnderTest
        this.summary.nOfIssuers = resp2.totalIssuers

        // Piggyback: keep the asset class selector aligned with the search page without an extra
        // round trip. The counters endpoint is scoped to the selected asset class.
        const slug = this.$store.getters.getSelectedAssetClass
        if (slug) {
          this.$store.dispatch('updateAssetClassCounters', {
            slug,
            activeProducts: resp2.activeProducts,
            totalIssuers: resp2.totalIssuers,
          })
        }
      }
    })
  },
  data: function () {
    return {
      summary: {
        nOfProducts: 0,
        nOfIssuers: 0,
        nOfActiveProducts: 0,
        nOfProductsUnderTest: 0,
      },
    }
  },
  computed: {
    canViewTestProducts() {
      const permissions = this.$store.getters.getPermissions.userPermissions
      return permissions != null ? permissions.canViewTestProducts : null
    },

    resultSummary() {
      return (
        this.$tc('search.label.available.count', this.summary.nOfProducts) +
        ' (' +
        this.$tc('search.label.available.active', this.summary.nOfActiveProducts) +
        ' ' +
        (this.canViewTestProducts
          ? this.$tc('search.label.available.underTest', this.summary.nOfProductsUnderTest)
          : '') +
        ') ' +
        this.$tc('search.label.available.issuer', this.summary.nOfIssuers)
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.grand-summary {
  background-color: #f3f4f6 !important;
  border-bottom: 1px solid #e5e7eb;
}

input:not([type='checkbox']),
select {
  width: 100%;
}

/*Bootstrap doesn't pass w-100 class to checkbox labels...such a mess*/
/deep/ div.w-100 > label {
  width: 100%;
}

.pointer label {
  cursor: pointer;
}

/deep/ .modal-filters .modal-dialog .modal-content > * {
  font-size: 0.8rem;
  background-color: var(--primaryBGColor) !important;
}
</style>
